// nécessite un refactor du nom de la variable de largeur, puisque nouvellement on l'appelle longueur.
const ShapeTypes = [
  {
    getNewShape: function () {
      return {
        id: 0,
        name: 'Rectangle',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        longueureCalculee: 0,
        nbVersants: 0,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape =>
          parseFloat(shape.largeur) * 2 - (shape.connexionFascia ? parseFloat(shape.largeur) : 0),
        calculFaite: shape => parseFloat(shape.largeur),
        calculArretier: shape =>
          shape.nbVersants === 1 ? parseFloat(shape.largeur) : parseFloat(shape.longueureCalculee),
        calculMoulure: shape =>
          (parseFloat(shape.longueureCalculee) * 2 + parseFloat(shape.largeur) * (shape.nbVersants === 1 ? 2 : 1)) *
          shape.nbVersants,
        formule: shape => parseFloat(shape.largeur) * parseFloat(shape.longueureCalculee) * shape.nbVersants,
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 1,
        name: 'Triangle',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        longueureCalculee: 0,
        nbVersants: 0,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape => parseFloat(shape.largeur) * shape.nbVersants,
        calculFaite: shape => 0,
        calculArretier: shape => Math.sqrt(Math.pow(shape.largeur / 2, 2) + Math.pow(shape.longueureCalculee, 2)) * 2,
        calculMoulure: shape => parseFloat(shape.largeur) * shape.nbVersants,
        formule: shape => ((parseFloat(shape.largeur) * parseFloat(shape.longueureCalculee)) / 2) * shape.nbVersants,
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 2,
        name: 'Trapèze',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        petiteBase: 0,
        longueureCalculee: 0,
        nbVersants: 0,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape => parseFloat(shape.largeur) * shape.nbVersants,
        calculFaite: shape => parseFloat(shape.petiteBase),
        calculArretier: shape =>
          Math.sqrt(Math.pow((shape.largeur - shape.petiteBase) / 2, 2) + Math.pow(shape.longueureCalculee, 2)) * 2,
        calculMoulure: shape => parseFloat(shape.largeur) * shape.nbVersants,
        formule: shape =>
          (((parseFloat(shape.largeur) + parseFloat(shape.petiteBase)) * parseFloat(shape.longueureCalculee)) / 2) *
          shape.nbVersants,
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 3,
        name: 'RectangleToitPlat',
        largeur: 0,
        longueur: 0,
        ajustement: 0,
        ajustementPermètre: 0,
        solin: 0,
        contreSolin: 0,
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 4,
        name: 'Trapèze rectangle',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        petiteBase: 0,
        longueureCalculee: 0,
        nbVersants: 0,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape => parseFloat(shape.largeur) * shape.nbVersants,
        calculFaite: shape => parseFloat(shape.petiteBase),
        calculArretier: shape =>
          Math.sqrt(Math.pow(shape.largeur - shape.petiteBase, 2) + Math.pow(shape.longueureCalculee, 2)),
        calculMoulure: shape => (parseFloat(shape.longueureCalculee) + parseFloat(shape.largeur)) * shape.nbVersants,
        formule: shape =>
          (((parseFloat(shape.largeur) + parseFloat(shape.petiteBase)) * parseFloat(shape.longueureCalculee)) / 2) *
          shape.nbVersants,
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 5,
        name: 'Triangle Lucarne',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        longueureCalculee: 0,
        nbVersants: 2,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape =>
          parseFloat(shape.base) * shape.nbVersants -
          (shape.connexionFascia ? parseFloat(shape.base) * shape.nbVersants : 0),
        calculFaite: shape => parseFloat(shape.largeur),
        calculArretier: shape =>
          Math.sqrt(Math.pow(parseFloat(shape.largeur), 2) + Math.pow(parseFloat(shape.longueureCalculee), 2)),
        calculMoulure: shape =>
          parseFloat(shape.longueureCalculee) * shape.nbVersants -
          (shape.connexionFascia ? shape.base * shape.nbVersants : 0),
        formule: shape =>
          ((parseFloat(shape.largeur) * parseFloat(shape.longueureCalculee)) / 2) * shape.nbVersants -
          (shape.connexionFascia
            ? (parseFloat(shape.base) *
                shape.nbVersants *
                Math.sqrt(Math.pow(parseFloat(shape.calculArretier(shape)), 2) - Math.pow(parseFloat(shape.base), 2))) /
              2
            : 0),
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 6,
        name: 'Trapèze Lucarne',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        petiteBase: 0,
        longueureCalculee: 0,
        nbVersants: 2,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape =>
          parseFloat(shape.petiteBase) * shape.nbVersants -
          (shape.connexionFascia ? parseFloat(shape.base) * shape.nbVersants : 0),
        calculFaite: shape => parseFloat(shape.largeur),
        calculArretier: shape =>
          Math.sqrt(
            Math.pow(parseFloat(shape.largeur) - parseFloat(shape.petiteBase), 2) +
              Math.pow(parseFloat(shape.longueureCalculee), 2),
          ),
        calculMoulure: shape =>
          parseFloat(shape.longueureCalculee) * shape.nbVersants +
          parseFloat(shape.petiteBase) * shape.nbVersants -
          (shape.connexionFascia ? shape.base * shape.nbVersants : 0),
        formule: shape =>
          (((parseFloat(shape.largeur) + parseFloat(shape.petiteBase)) * parseFloat(shape.longueureCalculee)) / 2) *
            shape.nbVersants -
          (shape.connexionFascia
            ? (parseFloat(shape.base) *
                shape.nbVersants *
                Math.sqrt(Math.pow(parseFloat(shape.calculArretier(shape)), 2) - Math.pow(parseFloat(shape.base), 2))) /
              2
            : 0),
      };
    },
  },
  {
    getNewShape: function () {
      return {
        id: 7,
        name: 'Rectangle Lucarne',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        longueureCalculee: 0,
        nbVersants: 2,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape => parseFloat(shape.largeur) * 2,
        calculFaite: shape => parseFloat(shape.largeur),
        calculArretier: shape => parseFloat(shape.longueureCalculee),
        calculMoulure: shape => parseFloat(shape.longueureCalculee) * 2 + parseFloat(shape.largeur) * 2,
        formule: shape => parseFloat(shape.largeur) * parseFloat(shape.longueureCalculee) * shape.nbVersants,
      };
    },
  },

  {
    getNewShape: function () {
      return {
        id: 8,
        name: 'Triangle Jonction',
        largeur: 0,
        hauteur: 0,
        pente: null,
        base: 0,
        longueureCalculee: 0,
        nbVersants: 2,
        jonction: null,
        connexionFascia: false,
        ventilateurToit: 0,
        surface: 0,
        perteSuggeree: 1,
        ajustement: 0,
        largeurSoffite: 0,
        surfaceTotale: 0,
        getBaseVersant: shape => parseFloat(shape.largeur) * shape.nbVersants,
        calculFaite: shape => 0,
        calculArretier: shape => 0,
        calculMoulure: shape => parseFloat(shape.largeur) * shape.nbVersants,
        formule: shape => ((parseFloat(shape.largeur) * parseFloat(shape.longueureCalculee)) / 2) * shape.nbVersants,
      };
    },
  },
];

function getNewShapeByName(name) {
  switch (name) {
    case 'rectangle':
      return ShapeTypes[0].getNewShape();
    case 'triangle':
      return ShapeTypes[1].getNewShape();
    case 'trapèze':
      return ShapeTypes[2].getNewShape();
    case 'trapèzerectangle':
      return ShapeTypes[4].getNewShape();
    case 'trianglelucarne':
      return ShapeTypes[5].getNewShape();
    case 'trapèzelucarne':
      return ShapeTypes[6].getNewShape();
    case 'rectanglelucarne':
      return ShapeTypes[7].getNewShape();
    case 'trianglejonction':
      return ShapeTypes[8].getNewShape();
  }
}

export default {
  ShapeTypes,
  getNewShapeByName,
};
